import PropTypes from 'prop-types';
import React from 'react';
import FootballMatchTeamStatus from './FootballMatchTeamStatus';
import MatchOdds from './FootballMatchOdds';
import FootballMatchOutcomeDescription from 'modules/Football/components/FootballMatchOutcomeDescription';
import {LocalDate, LocalTimeShort} from 'modules/Common/components/LocalDateTime';
import {MATCH_STATE_UPNEXT, MATCH_STATE_FINISHED} from 'modules/Football/consts'

const DASH_WITH_SPACES = ' - ';
const DASH_WITHOUT_SPACES = '-';

const HALF_TIME_LABEL = 'HT: ';
const FULL_TIME_LABEL = 'FT: ';
const AGGREGATE_SCORE_LABEL = 'Agg: ';

export default function FootballMatchSummary({matchLabel, match: {match_detail, homeTeam, awayTeam}}) {
  let matchStarted = !MATCH_STATE_UPNEXT.includes(match_detail.state)

  return (
      <div className="footballMatchSummary">
        <div className="footballMatchSummaryDef">
          <h1>{matchLabel}</h1>
          {match_detail.description}
        </div>
          <div className="footballMatchSummaryInfo">
            <span className="footballMatchInfoSpacing">
              <LocalDate className="footballMatchSummaryGreyText" iso={match_detail.match_date}/>
            </span>
            <span className="footballMatchInfoSpacing">
              <span className="footballMatchInfoSpacing">KO:</span>
              <LocalTimeShort className="footballMatchSummaryGreyText" iso={match_detail.match_date}/>
            </span>
            {match_detail.attendance &&
              <span className="footballMatchInfoSpacing">
                <span>ATT:&nbsp;</span>
                <span className="footballMatchSummaryGreyText">{`${commaSeperateNumber(match_detail.attendance)}`}</span>
              </span>
            }
            {match_detail.referee &&
              <span className="footballMatchInfoSpacing">
                <span>REF:&nbsp;</span>
                <span className="footballMatchSummaryGreyText">{`${match_detail.referee}`}</span>
              </span>
            }
          </div>
          <section className="footballMatchSummaryScores">
            <div className="footballMatchSummaryHomeTeam">
              <FootballMatchTeamStatus team={match_detail.team_score_a}  players={homeTeam.players.players}/>
            </div>
            <div className="footballMatchSummaryCurrentStatus">
              {makeScoreFromMatch(match_detail, DASH_WITH_SPACES)}
              <div className="footballScoreSummary">
                {matchStarted && <div className={MATCH_STATE_FINISHED.includes(match_detail.state) ? 'footballFullTime' : 'timer'}>{ match_detail.clock || ''}</div> }
                {matchStarted && makeScoreFromScore(match_detail.half_time_score, DASH_WITHOUT_SPACES, HALF_TIME_LABEL) }
                {matchStarted && match_detail.extra_time_score && makeScoreFromScore(match_detail.full_time_score, DASH_WITHOUT_SPACES, FULL_TIME_LABEL)}
                {makeScoreFromScore(match_detail.aggregate_score, DASH_WITHOUT_SPACES, AGGREGATE_SCORE_LABEL)}
              </div>
            </div>
            <div className="footballMatchSummaryAwayTeam">
              <FootballMatchTeamStatus team={match_detail.team_score_b} players={awayTeam.players.players}/>
            </div>
          </section>
          <FootballMatchOutcomeDescription matchOutcome={match_detail.match_outcome} penaltyShootoutScore={match_detail.penalty_shootout_score} style={"live-match"}/>
          <MatchOdds match={match_detail}/>

      </div>
  );
}

function makeScoreFromMatch(match_detail, seperator) {
  let home = match_detail.team_score_a.total_goals;
  let away = match_detail.team_score_b.total_goals;

  let score;
  if (MATCH_STATE_UPNEXT.includes(match_detail.state) || !home || !away) {
    score = <div className="versus">v</div>
  } else {
    score = <div className={MATCH_STATE_FINISHED.includes(match_detail.state) ? "ft-score-box" : "live-score-box"}>{formatScore({home, away}, seperator)}</div>
  }

  return score;
}

function makeScoreFromScore(score, seperator, prefix){
  if(score) {
    return <div className="footballPeriodScore">{formatScore(score, seperator, prefix)}</div>;
  }
}

function formatScore(score, seperator, prefix = '') {
  return `${prefix}${score.home}${seperator}${score.away}`;
}

function commaSeperateNumber(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

FootballMatchSummary.propTypes = {
  matchLabel: PropTypes.string,
  match: PropTypes.object
};



// WEBPACK FOOTER //
// ./modules/Football/components/FootballMatchSummary.js